import { referredByVet } from '@farmersdog/lead-browser-storage';

import { useVetCreatePlanSignup } from '../experiments/useVetCreatePlanSignup';

import { useVetCustomPlanContext } from './context';

import type { VetCustomPlanContextType } from './context';
import type { UseFeatureHook } from '../../types';

interface UseShowVetCustomizedPlanArgs {
  useFeature: UseFeatureHook;
}
export function useShowVetCustomizedPlan({
  useFeature,
}: UseShowVetCustomizedPlanArgs): VetCustomPlanContextType {
  // check if flag is on
  const { isVetCreatePlanSignupOn } = useVetCreatePlanSignup({ useFeature });
  const planContext = useVetCustomPlanContext();

  if (!isVetCreatePlanSignupOn) {
    return undefined;
  }

  // check if exists in session storage
  const sessionStorageReferredByVet = referredByVet.get();
  if (sessionStorageReferredByVet) {
    const referredByVetData = JSON.parse(
      sessionStorageReferredByVet
    ) as VetCustomPlanContextType;
    return referredByVetData;
  }
  // check if exists in context

  if (planContext) {
    return planContext;
  }

  return undefined;
}
